import React from "react";
import "./footer.css";

export default function Footer() {
	return <footer>© 2022 EventApp, Auckland New Zealand</footer>;
}
